import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import { useBodyScrollLock } from '@financial/common-hooks';
import style from './FlexibleLayout.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
/**
 * 반응형 공통 기본 레이아웃
 *
 * ```jsx
 * <FlexibleLayout
 *      colorType="gray150"
        topElement={
            <HeaderBrandMain serviceType={NF_SERVICE_TYPE.FINANCE} isMobile={false} isPayApp={false} />
        }
        bottomElement={
            <Footer type={FOOTER_TYPE.LOAN}/>
        }>
        // 컨텐츠를 FlexibleLayout children으로 주입한다
        <Home />
        <BottomNavigationBar active={NF_SERVICE_TYPE.FINANCE}/>
 * </FlexibleLayout>
 * ```
 */
function FlexibleLayout(_ref) {
  var isFullHeight = _ref.isFullHeight,
    containerClassName = _ref.containerClassName,
    innerClassName = _ref.innerClassName,
    topElement = _ref.topElement,
    bottomElement = _ref.bottomElement,
    _ref$colorType = _ref.colorType,
    colorType = _ref$colorType === void 0 ? 'gray200' : _ref$colorType,
    _ref$contentColorType = _ref.contentColorType,
    contentColorType = _ref$contentColorType === void 0 ? 'none' : _ref$contentColorType,
    _ref$widthType = _ref.widthType,
    widthType = _ref$widthType === void 0 ? 'full' : _ref$widthType,
    _ref$enableBodyScroll = _ref.enableBodyScrollLock,
    enableBodyScrollLock = _ref$enableBodyScroll === void 0 ? false : _ref$enableBodyScroll,
    children = _ref.children;
  useBodyScrollLock(enableBodyScrollLock);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', "type-".concat(colorType), containerClassName)
  }, topElement && /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, topElement), /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    id: "content",
    className: cx('inner', {
      'type-full-height': isFullHeight
    }, contentColorType !== 'none' ? _defineProperty({}, "type-".concat(contentColorType), contentColorType) : undefined, widthType !== 'full' ? _defineProperty({}, "width-type-".concat(widthType), widthType) : undefined, innerClassName)
  }, children)), bottomElement && /*#__PURE__*/React.createElement("div", {
    className: cx('row')
  }, bottomElement));
}

export { FlexibleLayout as default };
